module.exports = __webpack_public_path__ + "media/images/icons/payment-with-bg-5648c7745c925acd3930277012b93f21.svg";